// @flow

import React from 'react'
import { applyStylingHoc, type StyleOuterProps, type StyleProps } from '@fcse/tsbob/dist/lib/styling'
import CaseTeaser from '../CaseTeaser'
import CaseInfo from '../CaseInfo'
import CaseActionTeaser from '../CaseActionTeaser'
import baseStyles from './CaseBrand.scss'

type Props = {
  ...StyleProps,
  brand: Object
}

const CaseBrand = ({ styles, brand }: Props) => {
  return (
    <div className={styles.root}>
      {brand.logo && (
        <CaseTeaser
          title={brand.logo.title}
          list={brand.logo.list}
          img={brand.logo.img}
          styles={styles.logoTeaser}
          reversed
          imgStatic
        />
      )}
      {brand.colors && (
        <CaseTeaser
          title={brand.colors.title}
          list={brand.colors.list}
          img={brand.colors.img}
          styles={styles.colorsTeaser}
          imgStatic
        />
      )}
      {brand.recognition && (
        <CaseTeaser
          title={brand.recognition.title}
          text={brand.recognition.text}
          img={brand.recognition.img}
          styles={styles.recognitionTeaser}
          reversed
          imgWide
        />
      )}
      {brand.tech && (
        <CaseTeaser
          title={brand.tech.title}
          list={brand.tech.list}
          img={brand.tech.img}
          styles={styles.techTeaser}
          reversed
          imgStatic
        />
      )}
      {brand.advantages && (
        <CaseInfo
          title={brand.advantages.title}
          list={brand.advantages.list}
          img={brand.advantages.img}
          statement
          reversed
        />
      )}
      {brand.action && (
        <CaseActionTeaser title={brand.action.title} text={brand.action.text} img={brand.action.img} statement />
      )}
      {brand.design && (
        <CaseTeaser
          title={brand.design.title}
          list={brand.design.list}
          text={brand.design.text}
          img={brand.design.img}
          styles={styles.designTeaser}
          imgWide
        />
      )}
    </div>
  )
}

export default applyStylingHoc(baseStyles)<$Diff<Props, StyleProps> & StyleOuterProps, Function>(CaseBrand)
